export const NAV = {
  brand: 'nav-brand',
  homeLink: 'nav-home-link',
  menuLink: 'nav-menu-link',
  aboutLink: 'nav-about-link',
  contactLink: 'nav-contact-link',
  mobileToggle: 'nav-mobile-toggle',
  mobileHomeLink: 'mobile-nav-home-link',
  mobileMenuLink: 'mobile-nav-menu-link',
  mobileAboutLink: 'mobile-nav-about-link',
  mobileContactLink: 'mobile-nav-contact-link',
  callBtn: 'nav-call-btn',
};

export const HERO = {
  section: 'hero-section',
  ctaMenu: 'hero-cta-view-menu',
  ctaContact: 'hero-cta-contact',
};

export const HOME_PAGE = {
  page: 'home-page',
  about: 'home-about-section',
  featured: 'home-featured-section',
  featuredCard: 'home-featured-card',
  testimonials: 'home-testimonials-section',
  testimonialCard: 'home-testimonial-card',
  catering: 'home-catering-section',
  cateringCallBtn: 'home-catering-call-btn',
  cateringEmailBtn: 'home-catering-email-btn',
  app: 'home-app-section',
  appStoreBtn: 'home-app-appstore-btn',
  playStoreBtn: 'home-app-playstore-btn',
  cta: 'home-final-cta',
};

export const MENU_PAGE = {
  page: 'menu-page',
  tabs: 'menu-tabs',
  tab: 'menu-tab',
  item: 'menu-item',
  itemName: 'menu-item-name',
  itemPrice: 'menu-item-price',
};

export const CONTACT_PAGE = {
  page: 'contact-page',
  phone: 'contact-phone',
  address: 'contact-address',
  hours: 'contact-hours',
  email: 'contact-email',
  callBtn: 'contact-call-btn',
  directionsBtn: 'contact-directions-btn',
};

export const FOOTER = {
  root: 'site-footer',
  homeLink: 'footer-home-link',
  menuLink: 'footer-menu-link',
  aboutLink: 'footer-about-link',
  contactLink: 'footer-contact-link',
  termsLink: 'footer-terms-link',
};

export const TERMS_PAGE = {
  page: 'terms-page',
  section: 'terms-section',
};

export const ABOUT_PAGE = {
  page: 'about-page',
  hero: 'about-hero',
  story: 'about-story',
  pillars: 'about-pillars',
  pillar: 'about-pillar',
  founder: 'about-founder',
  timeline: 'about-timeline',
  timelineItem: 'about-timeline-item',
  app: 'about-app',
  cta: 'about-cta',
};
